import Attachment from '@/modules/Attachment/locales'
import Screening from '@/modules/Screening/locales'

const resources = {
  en: {
    screening: Screening.en,
    attachment: Attachment.en,
  },
  pt: {
    screening: Screening.pt,
    attachment: Attachment.pt,
  },
  es: {
    screening: Screening.es,
    attachment: Attachment.es,
  },
}
export default resources
